/* eslint-disable react/display-name */
/* eslint-disable @next/next/no-css-tags */
/* eslint-disable @next/next/no-img-element */

import { sanityClient, PortableText, urlFor } from '../../lib/sanity';

import styles from '../../styles/Home.module.scss';

import WhiteBlueIllustration from '../../components/elements/WhiteBlueIllustration';

import IntroCopyBlock from '../../components/elements/IntroCopyBlock';

/* eslint-disable @next/next/no-img-element */

import Spacer from '../../components/elements/Spacer';
import StandardLayout from '../../components/layouts/StandardLayout';
import Button from '../../components/elements/Button';
import GreenQuote from '../../components/GreenQuote';
import Link from 'next/link';

const jobsPageInfoQuery = `*[_id=="7c854f88-a16e-4e57-b6ac-95293e2cf9df"] {
  title,
  meta,
  introheading,
  pinkmessage,
  introcopy,
  pagequote,
  paragraphs,
  customblocks,
  headerimage,

  "companyInfoQuery" : *[_type=="company"] {
    overlaytitle,
    message,
    title,
    footer,
    sociallinks,
    email,
    numbers
  },
  "nurseryQuery" : *[_type=="nurseries"] {
    address,
    linkaddress,
    "manuscriptURL": manuscript.asset->url,
    mapimage
  }
}`;

const serializers = {
  marks: {
    link: ({ children, mark }) =>
      mark.blank ? (
        <a href={mark.href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        <a href={mark.href}>{children}</a>
      )
  }
};

export default function Home({ Jobs }) {
  const PageInfo = Jobs[0];

  const Company = PageInfo.companyInfoQuery;
  const Nurseries = PageInfo.nurseryQuery;

  const Paragraphs = PageInfo.paragraphs;
  const PageQuote = PageInfo.pagequote;

  return (
    <>
      <StandardLayout CompanyInfo={Company} Nurseries={Nurseries} PageInfo={PageInfo} headerWidth={1920} headerHeight={600} headerMinHeight={300} hideLeadImage={false} hideLink={true}>
        <div className={styles.mainContent}>
          <div className="container">
            <IntroCopyBlock PageInfo={PageInfo} />

            <Spacer mt={3} />
            {Paragraphs?.length > 0 &&
              Paragraphs.map((paragraph, index) => (
                <div className="halfgrid alternate jobspadding" key={index}>
                  <div className="firsthalf">
                    <img src={urlFor(paragraph.image).width(850).url()} alt={paragraph.name} className={styles.imgclass} />
                  </div>
                  <div className="secondhalf">
                    <h2>{paragraph.title}</h2>

                    <PortableText blocks={paragraph.paragraphcopy} serializers={serializers} />

                    {index == 0 && (
                      <div className={styles.buttonStyler}>
                        <Link href={'/careers/apply'}>
                          <button className={styles.telTo}>Apply Now</button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>

        {PageQuote && <GreenQuote quote={PageQuote} />}
        <WhiteBlueIllustration />
      </StandardLayout>
    </>
  );
}

export async function getStaticProps() {
  const Jobs = await sanityClient.fetch(jobsPageInfoQuery);
  return { props: { Jobs } };
}

/* <Paraloop CopyLoop={PageInfo.paragraphs} /> */
